import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminErrorLogDetailPage, type AdminErrorLogDetailPageProps } from '../ui/admin/AdminErrorLogDetailPage';

export function AdminErrorLogDetailPageContainer(props: AdminErrorLogDetailPageProps) {
  return <AdminErrorLogDetailPage {...props} />;
}

export function mountAdminErrorLogDetailPage(
  container: HTMLElement,
  props: AdminErrorLogDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminErrorLogDetailPageContainer {...props} />);
  return root;
}

export default AdminErrorLogDetailPageContainer;
